var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-45",
    "data-name": "50_Kids_Icons-45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#eb7fa8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4954",
    "data-name": "Group 4954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4894",
    "data-name": "Group 4894",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4886",
    "data-name": "Group 4886",
    transform: "translate(30.391 37.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4880",
    "data-name": "Group 4880",
    transform: "translate(21.091)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(1.87 3.815) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_294",
    "data-name": "Ellipse 294",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(0 0.796) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4881",
    "data-name": "Group 4881",
    transform: "translate(18.766 4.013)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_295",
    "data-name": "Ellipse 295",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "translate(1.804 3.68) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_296",
    "data-name": "Ellipse 296",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "translate(0 0.767) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882",
    transform: "translate(14.879 6.773)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "translate(1.738 3.544) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "translate(0 0.739) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883",
    transform: "translate(10.044 8.262)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_299",
    "data-name": "Ellipse 299",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "translate(1.672 3.409) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "translate(0 0.711) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4884",
    "data-name": "Group 4884",
    transform: "translate(4.88 8.459)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "translate(1.605 3.274) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_302",
    "data-name": "Ellipse 302",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "translate(0 0.683) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4885",
    "data-name": "Group 4885",
    transform: "translate(0 7.344)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_303",
    "data-name": "Ellipse 303",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "translate(1.539 3.139) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "translate(0 0.655) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(24.41 1.104) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4893",
    "data-name": "Group 4893",
    transform: "translate(17.799 37.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4887",
    "data-name": "Group 4887",
    transform: "translate(1.448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(0 8.772) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(1.871 5.753) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4888",
    "data-name": "Group 4888",
    transform: "translate(4.101 4.013)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "translate(0 8.461) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "translate(1.804 5.549) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4889",
    "data-name": "Group 4889",
    transform: "translate(8.317 6.774)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "translate(0 8.15) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "translate(1.738 5.345) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4890",
    "data-name": "Group 4890",
    transform: "translate(13.48 8.263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "translate(0 7.84) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "translate(1.672 5.141) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4891",
    "data-name": "Group 4891",
    transform: "translate(18.973 8.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "translate(0 7.529) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "translate(1.605 4.937) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4892",
    "data-name": "Group 4892",
    transform: "translate(24.181 7.345)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "translate(0 7.218) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_317",
    "data-name": "Ellipse 317",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "translate(1.539 4.734) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(0 6.061) rotate(-83.24)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4895",
    "data-name": "Group 4895",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_319",
    "data-name": "Ellipse 319",
    cx: 21.875,
    cy: 14.063,
    rx: 21.875,
    ry: 14.063,
    transform: "translate(18.125 22.326)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4896",
    "data-name": "Group 4896",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M115.961,399.234l-.009-.144c0-8.781-3.287-17.288-7.3-18.908L91.559,373.3a22.645,22.645,0,0,0-14.6-.019L59.62,380.2c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-44.134 -313.94)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4897",
    "data-name": "Group 4897",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M224.15,250.8a6.825,6.825,0,0,1-6.825,6.825H216.5a6.825,6.825,0,0,1-6.825-6.825V233.22A6.825,6.825,0,0,1,216.5,226.4h.828a6.825,6.825,0,0,1,6.825,6.825Z",
    transform: "translate(-176.912 -191.021)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4899",
    "data-name": "Group 4899",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4898",
    "data-name": "Group 4898",
    transform: "translate(26.099 14.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M194.835,119.859a13.9,13.9,0,0,1-13.9,13.9h0a13.9,13.9,0,0,1-13.9-13.9V108.3a13.9,13.9,0,0,1,13.9-13.9h0a13.9,13.9,0,0,1,13.9,13.9v11.563Z",
    transform: "translate(-167.033 -94.396)",
    fill: "#d67f5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4900",
    "data-name": "Group 4900",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(32.67 38.487)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(43.933 38.487)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4901",
    "data-name": "Group 4901",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M162.891,88.282c-9.523,0-17.242,8.367-17.242,18.689a19.809,19.809,0,0,0,2.338,9.4l.565-4.794a11.025,11.025,0,0,1,10.949-9.734h6.778a11.025,11.025,0,0,1,10.95,9.732l.567,4.8a19.812,19.812,0,0,0,2.338-9.4C180.134,96.649,172.414,88.282,162.891,88.282Z",
    transform: "translate(-122.891 -74.488)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4902",
    "data-name": "Group 4902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M243.3,272.071a2.616,2.616,0,0,1-5.106.591,2.768,2.768,0,0,0-.125.78,2.8,2.8,0,1,0,5.6,0A2.765,2.765,0,0,0,243.3,272.071Z",
    transform: "translate(-200.873 -229.56)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4903",
    "data-name": "Group 4903",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M115.891,413.291c0-8.781-3.287-17.288-7.3-18.908L95,388.908a12,12,0,0,1-21.828.058L59.559,394.4c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144H115.9Z",
    transform: "translate(-44.083 -328.141)",
    fill: "#ffc34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4904",
    "data-name": "Group 4904",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M226.93,295.282a5.359,5.359,0,0,1-7.119,0c-1.351-1.272-3.392.761-2.037,2.037a8.3,8.3,0,0,0,11.193,0c1.355-1.276-.686-3.309-2.037-2.037Z",
    transform: "translate(-183.371 -248.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4919",
    "data-name": "Group 4919",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4911",
    "data-name": "Group 4911",
    transform: "translate(24.202 14.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_322",
    "data-name": "Ellipse 322",
    cx: 2.96,
    cy: 3.453,
    rx: 2.96,
    ry: 3.453,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 5.408)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4906",
    "data-name": "Group 4906",
    transform: "translate(1.469 2.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 2.855,
    cy: 3.331,
    rx: 2.855,
    ry: 3.331,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.512)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    cx: 2.855,
    cy: 3.331,
    rx: 2.855,
    ry: 3.331,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.642, 5.216)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4907",
    "data-name": "Group 4907",
    transform: "translate(4.842 6.255)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    cx: 2.75,
    cy: 3.208,
    rx: 2.75,
    ry: 3.208,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.236)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    cx: 2.75,
    cy: 3.208,
    rx: 2.75,
    ry: 3.208,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.545, 5.025)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4908",
    "data-name": "Group 4908",
    transform: "translate(9.524 9.243)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    cx: 2.645,
    cy: 3.086,
    rx: 2.645,
    ry: 3.086,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.96)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_328",
    "data-name": "Ellipse 328",
    cx: 2.645,
    cy: 3.086,
    rx: 2.645,
    ry: 3.086,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.448, 4.833)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4909",
    "data-name": "Group 4909",
    transform: "translate(14.919 11.07)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 2.54,
    cy: 2.963,
    rx: 2.54,
    ry: 2.963,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.684)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 2.54,
    cy: 2.963,
    rx: 2.54,
    ry: 2.963,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.351, 4.641)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4910",
    "data-name": "Group 4910",
    transform: "translate(20.434 11.531)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    cx: 2.435,
    cy: 2.841,
    rx: 2.435,
    ry: 2.841,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.408)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    cx: 2.435,
    cy: 2.841,
    rx: 2.435,
    ry: 2.841,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.254, 4.45)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4918",
    "data-name": "Group 4918",
    transform: "translate(25.939 14.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4912",
    "data-name": "Group 4912",
    transform: "translate(21.142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_333",
    "data-name": "Ellipse 333",
    cx: 3.453,
    cy: 2.96,
    rx: 3.453,
    ry: 2.96,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.808)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4913",
    "data-name": "Group 4913",
    transform: "translate(17.34 2.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_334",
    "data-name": "Ellipse 334",
    cx: 3.331,
    cy: 2.855,
    rx: 3.331,
    ry: 2.855,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.642, 5.005)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_335",
    "data-name": "Ellipse 335",
    cx: 3.331,
    cy: 2.855,
    rx: 3.331,
    ry: 2.855,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.709)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4914",
    "data-name": "Group 4914",
    transform: "translate(14.373 6.255)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 3.208,
    cy: 2.75,
    rx: 3.208,
    ry: 2.75,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.545, 4.821)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 3.208,
    cy: 2.75,
    rx: 3.208,
    ry: 2.75,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.609)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4915",
    "data-name": "Group 4915",
    transform: "translate(10.098 9.243)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 3.086,
    cy: 2.645,
    rx: 3.086,
    ry: 2.645,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.448, 4.637)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 3.086,
    cy: 2.645,
    rx: 3.086,
    ry: 2.645,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.509)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4916",
    "data-name": "Group 4916",
    transform: "translate(5.108 11.07)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 2.963,
    cy: 2.54,
    rx: 2.963,
    ry: 2.54,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.351, 4.453)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 2.963,
    cy: 2.54,
    rx: 2.963,
    ry: 2.54,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.41)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4917",
    "data-name": "Group 4917",
    transform: "translate(0 11.531)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 2.841,
    cy: 2.435,
    rx: 2.841,
    ry: 2.435,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.254, 4.269)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 2.841,
    cy: 2.435,
    rx: 2.841,
    ry: 2.435,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.31)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4934",
    "data-name": "Group 4934",
    transform: "translate(10.76 10.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4926",
    "data-name": "Group 4926",
    transform: "translate(5.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4920",
    "data-name": "Group 4920",
    transform: "translate(19.229 0.742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.183)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_345",
    "data-name": "Ellipse 345",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.812, 7.641)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4921",
    "data-name": "Group 4921",
    transform: "translate(14.923)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    "data-name": "Ellipse 346",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.035)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.784, 7.37)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4922",
    "data-name": "Group 4922",
    transform: "translate(10.397 1.249)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.887)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.755, 7.099)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4923",
    "data-name": "Group 4923",
    transform: "translate(6.102 4.066)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_350",
    "data-name": "Ellipse 350",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.738)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_351",
    "data-name": "Ellipse 351",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.726, 6.828)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4924",
    "data-name": "Group 4924",
    transform: "translate(2.486 8.031)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_352",
    "data-name": "Ellipse 352",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.59)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_353",
    "data-name": "Ellipse 353",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.697, 6.558)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4925",
    "data-name": "Group 4925",
    transform: "translate(0 12.721)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_354",
    "data-name": "Ellipse 354",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.442)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_355",
    "data-name": "Ellipse 355",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.668, 6.287)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_356",
    "data-name": "Ellipse 356",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 22.169, 5.818)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4933",
    "data-name": "Group 4933",
    transform: "translate(0 5.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4927",
    "data-name": "Group 4927",
    transform: "translate(0.741 19.228)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 5.309)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.457, 6.121)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4928",
    "data-name": "Group 4928",
    transform: "translate(0 14.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 5.121)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.335, 5.904)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4929",
    "data-name": "Group 4929",
    transform: "translate(1.249 10.396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.932)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_362",
    "data-name": "Ellipse 362",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.212, 5.687)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4930",
    "data-name": "Group 4930",
    transform: "translate(4.067 6.101)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_363",
    "data-name": "Ellipse 363",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.744)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_364",
    "data-name": "Ellipse 364",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 3.09, 5.47)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4931",
    "data-name": "Group 4931",
    transform: "translate(8.032 2.486)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_365",
    "data-name": "Ellipse 365",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.556)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_366",
    "data-name": "Ellipse 366",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 2.967, 5.253)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4932",
    "data-name": "Group 4932",
    transform: "translate(12.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 4.368)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_368",
    "data-name": "Ellipse 368",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 2.845, 5.036)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 1.635, 27.477)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4949",
    "data-name": "Group 4949",
    transform: "translate(32.622 10.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935",
    transform: "translate(2.128 0.741)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_370",
    "data-name": "Ellipse 370",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.813, 4.55)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_371",
    "data-name": "Ellipse 371",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 8.008)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936",
    transform: "translate(6.778)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_372",
    "data-name": "Ellipse 372",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.784, 4.389)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.724)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937",
    transform: "translate(11.647 1.249)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.755, 4.228)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.44)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938",
    transform: "translate(16.287 4.067)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.726, 4.066)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_377",
    "data-name": "Ellipse 377",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 7.156)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4939",
    "data-name": "Group 4939",
    transform: "translate(20.246 8.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_378",
    "data-name": "Ellipse 378",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.697, 3.905)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_379",
    "data-name": "Ellipse 379",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.872)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4940",
    "data-name": "Group 4940",
    transform: "translate(23.076 12.723)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_380",
    "data-name": "Ellipse 380",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0.668, 3.744)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_381",
    "data-name": "Ellipse 381",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.589)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_382",
    "data-name": "Ellipse 382",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.619, -0.785, 0.785, 0.619, 0, 6.185)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4948",
    "data-name": "Group 4948",
    transform: "translate(13.86 5.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4942",
    "data-name": "Group 4942",
    transform: "translate(9.819 19.229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_383",
    "data-name": "Ellipse 383",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.458, 3.586)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_384",
    "data-name": "Ellipse 384",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.398)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4943",
    "data-name": "Group 4943",
    transform: "translate(10.993 14.923)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.335, 3.458)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.242)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4944",
    "data-name": "Group 4944",
    transform: "translate(10.177 10.397)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.213, 3.331)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 4.086)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4945",
    "data-name": "Group 4945",
    transform: "translate(7.791 6.102)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 3.09, 3.204)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_390",
    "data-name": "Ellipse 390",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.93)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4946",
    "data-name": "Group 4946",
    transform: "translate(4.259 2.486)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 2.967, 3.077)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_392",
    "data-name": "Ellipse 392",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.774)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4947",
    "data-name": "Group 4947"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 2.845, 2.95)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0, 3.618)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 12.384, 25.755)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4951",
    "data-name": "Group 4951",
    transform: "translate(31.738 35.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M204.312,231.813a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.322,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-203.124 -229.703)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4952",
    "data-name": "Group 4952",
    transform: "translate(43.477 35.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M282.821,230.844a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-278.255 -229.703)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar10);
export default __webpack_public_path__ + "static/media/avatar10.328c741f3222d95b41703f827bca5207.svg";
export { ForwardRef as ReactComponent };